/* SnapshotComponent.js */

"use strict";

const BaseActivityViewColumnComponent = require("../BaseActivityViewColumnComponent");
const Renderer = require("./SnapshotRenderer");
const _ = require("lodash");

class SnapshotColumnComponent extends BaseActivityViewColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);

        const normalizedActivity = this._normalizeActivity(activityEntity);

        this._snapshot = _.get(normalizedActivity, "snapshot.snapshot", "");

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._snapshot = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal.snapshot)) {
            this.setSnapshot(newVal.snapshot);
        }
    }

    getValue() {
        return {
            snapshot: this.getSnapshot()
        };
    }

    setSnapshot(newVal) {
        this._snapshot = newVal;
        this.emit("Snapshot", newVal);
        return this;
    }

    getSnapshot() {
        return this._snapshot;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SnapshotColumnComponent;
